import {
  getTawkCustomStyle,
  scheduleTawkReposition,
  TAWK_READY_EVENT,
} from './utils/tawkPosition';
import { getTawkSiteConfig, type TawkSiteConfig } from './tawkSites';

const TAWK_POLL_INTERVAL_MS = 100;
const TAWK_MAX_POLL_ATTEMPTS = 120;

function setTawkWidgetVisible(visible: boolean): boolean {
  window.__tawkShouldShow = visible;

  const api = window.Tawk_API;
  if (!api?.showWidget) return false;

  try {
    visible ? api.showWidget() : api.hideWidget?.();
    return true;
  } catch {
    return false;
  }
}

function openTawkChat(): void {
  if (window.Tawk_API?.maximize) {
    window.Tawk_API.maximize();
    return;
  }
  if (window.Tawk_API?.toggle) {
    window.Tawk_API.toggle();
    return;
  }
  setTawkWidgetVisible(true);
}

function injectTawkScript(site: TawkSiteConfig): void {
  if (document.querySelector('script[src*="embed.tawk.to"]')) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://embed.tawk.to/${site.propertyId}/${site.widgetId}`;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');
  script.onerror = () => {
    console.warn(
      '[Tawk] Failed to load. Add this domain under Allowed Domains in Tawk.to dashboard:',
      window.location.hostname
    );
  };
  document.head.appendChild(script);
}

function pollUntilWidgetReady(): void {
  if (setTawkWidgetVisible(window.__tawkShouldShow ?? true)) return;

  let attempts = 0;
  const pollId = window.setInterval(() => {
    attempts += 1;
    if (
      setTawkWidgetVisible(window.__tawkShouldShow ?? true) ||
      attempts >= TAWK_MAX_POLL_ATTEMPTS
    ) {
      window.clearInterval(pollId);
    }
  }, TAWK_POLL_INTERVAL_MS);
}

let tawkInitialized = false;

export function initTawk(): void {
  if (tawkInitialized) return;
  const site = getTawkSiteConfig(window.location.hostname);
  if (!site) return;
  tawkInitialized = true;

  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();
  injectTawkScript(site);

  window.__tawkShouldShow = true;
  window.Tawk_API.customStyle = getTawkCustomStyle();
  window.setTawkWidgetVisible = setTawkWidgetVisible;
  window.openTawkChat = openTawkChat;

  window.Tawk_API.onLoad = () => {
    window.isTawkEnabled = true;
    window.dispatchEvent(new Event(TAWK_READY_EVENT));
    scheduleTawkReposition();
    setTawkWidgetVisible(window.__tawkShouldShow ?? true);
  };

  window.Tawk_API.onChatStarted = () => {
    setTawkWidgetVisible(true);
  };

  pollUntilWidgetReady();

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      setTawkWidgetVisible(window.__tawkShouldShow ?? true);
    }
  });
}
